<template>
  <div id="batch-details" v-if="isSignedIn">

    <div id="batch-title">
      <a-space>
        <a-icon type="arrow-left" @click="$router.push('/batch-history')"/>
        <h1>Batch Details</h1>
      </a-space>
    </div>
    <div id="batch-description">
      <a-skeleton :loading="batchRecord.id==undefined" active :title="false" :paragraph="{ rows: 5 }">
        <a-descriptions layout="vertical" :colon=false size="small">
          <a-descriptions-item label="ID">
            {{batchRecord.id}}
          </a-descriptions-item>
          <a-descriptions-item label="Start Date">
            {{batchRecord.start_date ? formatDateMMDDYYYY(batchRecord.start_date) : ''}}
          </a-descriptions-item>
          <a-descriptions-item label="End Date">
            {{batchRecord.end_date ? formatDateMMDDYYYY(batchRecord.end_date) : ''}}
          </a-descriptions-item>
          <a-descriptions-item label="Type">
            {{batchRecord.batch_type}}
          </a-descriptions-item>
          <a-descriptions-item label="Created At">
            {{formatDate(batchRecord.created_at)}}
          </a-descriptions-item>
          <a-descriptions-item label="Updated At">
            {{formatDate(batchRecord.updated_at)}}
          </a-descriptions-item>
          <a-descriptions-item label="Import Reference ID">
            {{batchRecord.import_reference_id_regular}}
          </a-descriptions-item>
        </a-descriptions>
      </a-skeleton>
    </div>

    <!-- WORKED TIME ENTRIES TAB -->
    <a-tabs default-active-key="batch-entries">
      <a-tab-pane key="time-entries" tab="Time Entries">
        <time-entries :batch-id="getBatchId" />
      </a-tab-pane>

      <!-- PTO TAB -->
      <a-tab-pane key="pto" tab="PTO" :forceRender="true">
        <pto-entries :batch-id="getBatchId" />
      </a-tab-pane>

      <!-- UNACKNOWLEDGED ENTRIES TAB-->
      <a-tab-pane key="unacked-entries" tab="Unacknowledged Errors" :forceRender="true">
        <unacknowledged-entries :batchId="getBatchId" />
      </a-tab-pane>
    </a-tabs>

  </div>
</template>

<script>
  import moment from "moment";
  import { mapState, mapGetters, mapMutations } from "vuex";
  import axios from "axios";
  import TimeEntries from "../components/TimeEntries";
  import UnacknowledgedEntries from "../components/UnacknowledgedEntries";
  import PtoEntries from "../components/PTOEntries";

  const columns = [
    //For starters let's have the
    // Employee ID (from Workday),
    // Employee Name,
    // Date (in US mm/dd/yyyy format is fine),
    // the number of hours and
    // status
    {
      title: "Employee ID",
      dataIndex: "workday_emp_id",
      key: "workday_emp_id",
      scopedSlots: { customRender: "workday_emp_id" }
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      key: "employee_name",
      scopedSlots: { customRender: "employee_name" }
    },
    {
      title: "Total Hours",
      dataIndex: "employee_total_minutes",
      key: "total_hours",
      scopedSlots: { customRender: "total_hours" }
    },
  ];

  export default {
    name: "BatchDetails",
    components: { PtoEntries, UnacknowledgedEntries, TimeEntries },
    computed: {
      ...mapState(["apiUrl"]),
      ...mapGetters('auth', ["isSignedIn","getUUID"]),
      getBatchId() {
        return this.batchId;
      },
    },
    data() {
      return {
        columns: columns,
        batchRecord: {},
        isLoading: false,
        dateFormat: "YYYY-MM-DD",
      };
    },
    methods: {
      ...mapMutations('auth', ["signInFailed"]),
      fetchBatch() {
        this.isLoading = true;
        axios({
          url: `${this.apiUrl}/getBatchEntries`,
          params: {
            action: "FETCH_BATCH",
            batchId: this.batchId,
          },
          headers: {
            Authorization: 'Bearer ' + this.getUUID
          }
        })
          .then(rslt => {
            this.batchRecord = rslt.data[0];
            this.isLoading = false;
          })
          .catch(err => {

            //In the case the endpoint returns a 401, that means
            // our session token has expired. Reroute to /sso-login
            if(err.response.status == 401) {
              this.signInFailed("Session has expired.");
              this.$router.push(`/sso-login`);
            }
            else {
              alert("Unable to load batch");
              this.isLoading = false;
            }
          });
      },
      formatDateMMDDYYYY(date) {
        return moment(date).format("MM/DD/YYYY");
      },
      formatDate(d) {
        const date = new Date(d);
        return date.toLocaleString();
      },
    },
    mounted() {
      this.fetchBatch();
    },
    props: ["batchId"]
  }
</script>

<style lang="scss" scoped>
  #batch-title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    h1 {
      margin: 0;
    }
  }

  #batch-description {
    margin: 20px;

    ::v-deep {
      .ant-descriptions-item-label {
        font-weight: bold;
      }
    }
  }

  ::v-deep {
    .ant-table-thead > tr > th,
    .center-col {
      text-align: center;

      &[key="PageName"] {
        text-align: left;
      }
    }
    .clickable {
      cursor: pointer;
    }

    .ant-tabs-tabpane {
      button {
        margin: 0 0 10px 10px;
      }
    }
  }
</style>